import { useState } from 'react';
import { toast } from 'sonner';
import { feedbackApi } from '@/api/feedback';
import { Dislike, Like1 } from '@/components/icons';
import { Text } from '@/components/system';
import { Button } from '@/components/ui/button';

type ArticleFeedbackProps = {
    articleSlug: string;
};

export function ArticleFeedback({ articleSlug }: ArticleFeedbackProps) {
    const [status, setStatus] = useState<'idle' | 'sending' | 'sent'>('idle');

    const sendFeedback = async (helpful: boolean) => {
        setStatus('sending');
        try {
            await feedbackApi.sendFeedback({
                rating: helpful ? 5 : 1,
                text: `[central-de-ajuda] artigo: ${articleSlug} | ajudou: ${helpful ? 'sim' : 'não'}`,
            });
            setStatus('sent');
        } catch {
            setStatus('idle');
            toast.error('Não foi possível registrar sua resposta. Tente novamente.');
        }
    };

    if (status === 'sent') {
        return (
            <div className="flex items-center justify-center rounded-xl border border-border/80 bg-surface-muted/60 px-4 py-5">
                <Text variant="body" className="font-medium">
                    Obrigado pela resposta! Ela nos ajuda a melhorar os guias.
                </Text>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center gap-3 rounded-xl border border-border/80 bg-surface-muted/60 px-4 py-5 sm:flex-row sm:justify-center sm:gap-6">
            <Text variant="body" className="font-medium">
                Este artigo ajudou?
            </Text>
            <div className="flex items-center gap-2">
                <Button
                    variant="outline"
                    size="sm"
                    disabled={status === 'sending'}
                    onClick={() => sendFeedback(true)}
                >
                    <Like1 className="size-4" />
                    Sim
                </Button>
                <Button
                    variant="outline"
                    size="sm"
                    disabled={status === 'sending'}
                    onClick={() => sendFeedback(false)}
                >
                    <Dislike className="size-4" />
                    Não
                </Button>
            </div>
        </div>
    );
}
